import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  IconButton,
  FormHelperText,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import * as types from "../../redux/action/ActionType";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch, useSelector } from "react-redux";
import { CalendarMonthOutlined } from "@mui/icons-material";

const selectBillingFilter = (state) => state.billingStatementFilter;

export default function BillingStatementFilter(props) {
  const {
    open,
    handleClose,
    filter,
    setFilter,
    filterInitial,
    setApplyFilterFlag,
    submitFilter,
    billPeriod,
  } = props;
  const reduxFilter = useSelector(selectBillingFilter);
  const dispatch = useDispatch();
  console.log(reduxFilter, "reduxxxxxxxxxxxxxxxxx");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [tempFilter, setTempFilter] = useState(filter);
  const [dateErrors, setDateErrors] = useState({ startDate: "", endDate: "" });
  console.log(tempFilter, "tempFiltertempFilter");
  useEffect(() => {
    setTempFilter(reduxFilter.filterValues);
    // setDateErrors({ startDate: "", endDate: "" });
  }, [reduxFilter.filterValues]);

  const handleChangeBillingEndDate = (val) => {
    const formattedDate = val ? dayjs(val).format("YYYY-MM-DD") : "";
    setTempFilter((prevFilter) => ({
      ...prevFilter,
      billingEndDate: formattedDate,
      billingEndDateDatepicker: val,
    }));
  };

  const handleChangeBillingStartDate = (val) => {
    const formattedDate = val ? dayjs(val).format("YYYY-MM-DD") : "";
    setTempFilter((prevFilter) => ({
      ...prevFilter,
      billingStartDate: formattedDate,
      billingStartDateDatepicker: val,
    }));
  };

  const handleChangeInvoiceStatus = (event) => {
    const {
      target: { value },
    } = event;
    setTempFilter((prevState) => ({ ...prevState, invoiceStatus: value }));
  };

  const resetFun = () => {
    setTempFilter(filterInitial);
    setDateErrors({ startDate: "", endDate: "" });
  };

  const validateDates = (values) => {
    let errors = {};
    const start = values.billingStartDateDatepicker
      ? dayjs(values.billingStartDateDatepicker)
      : null;
    const end = values.billingEndDateDatepicker
      ? dayjs(values.billingEndDateDatepicker)
      : null;

    if (!start && end) {
      errors.startDate = "Start date is required.";
    } else if (start && !start.isValid()) {
      errors.startDate = "Invalid date";
    }

    if (!end && start) {
      errors.endDate = "End date is required.";
    } else if (end && !end.isValid()) {
      errors.endDate = "Invalid date";
    }

    if (
      start &&
      end &&
      start.isValid() &&
      end.isValid() &&
      !start.isBefore(end) &&
      !start.isSame(end)
    ) {
      errors.startDate =
        "The 'From' date must be before or equal to the 'To' date.";
      errors.endDate =
        "The 'To' date must be after or equal to the 'From' date.";
    }

    return errors;
  };

  const {
    handleSubmit,
    handleChange,
    setFieldValue,
    values,
    errors,
    touched,
    setTouched,
    resetForm,
    validateForm,
  } = useFormik({
    initialValues: tempFilter,
    enableReinitialize: true,
    validate: validateDates,
    onSubmit: () => {
      validateForm().then((errors) => {
        if (!Object.keys(errors).length) {
          setApplyFilterFlag(true);
          setFilter(tempFilter);
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: { filterValues: tempFilter },
          });
          submitFilter();
          handleClose();
        }
      });
    },
  });
  console.log(errors, "errorsssssssss", touched);
  const isButtonDisabled = () => {
    return (
      !tempFilter.billingStartDateDatepicker ||
      !tempFilter.billingEndDateDatepicker ||
      !tempFilter.invoiceStatus
    );
  };

  const clearProject = () => {
    setTempFilter({ ...tempFilter, invoiceStatus: "" });
  };

  return (
    <>
      <Dialog
        className="user-filter-popup cst-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        component={"form"}
        onSubmit={handleSubmit}
      >
        <Stack
          sx={{ p: "25px 34px" }}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography className="model-title">Filter Properties</Typography>
          <Button
            className="edit-btn"
            variant="outlined"
            startIcon={
              <span className="material-symbols-outlined">history</span>
            }
            onClick={resetFun}
          >
            Reset Filter
          </Button>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          {/* <p style={{ mb: "0px" }} className="label oh-label">
            Selected Project has {billPeriod} days Billing Period
          </p> */}

          <Stack direction="row" alignItems="baseline" spacing={4}>
            <FormControl
              sx={{ width: "100%" }}
              variant="standard"
              error={!!(touched.billingStartDateDatepicker && errors.startDate)}
            >
              <p className="label">Billing Period Start Date:</p>
              <LocalizationProvider
                sx={{ marginBottom: "0px !important" }}
                dateAdapter={AdapterDayjs}
              >
                <DatePicker
                  className="filter-biiling-date"
                  name="billingStartDateDatepicker"
                  id="billingStartDateDatepicker"
                  value={tempFilter?.billingStartDateDatepicker || null}
                  onChange={(dateValue) =>
                    handleChangeBillingStartDate(dateValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        ".MuiInputBase-root": {
                          borderColor:
                            touched.billingStartDateDatepicker &&
                            errors.startDate
                              ? "red"
                              : tempFilter?.billingEndDateDatepicker &&
                                params?.inputProps?.disabled
                              ? "yellow"
                              : "",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor:
                              touched.billingStartDateDatepicker &&
                              errors.startDate
                                ? "red"
                                : tempFilter?.billingEndDateDatepicker &&
                                  params?.inputProps?.disabled
                                ? "yellow"
                                : "",
                          },
                        },
                        ".MuiInputBase-root.Mui-error": {
                          borderColor: "red",
                        },
                      }}
                    />
                  )}
                  allowClear
                  shouldDisableDate={(date) =>
                    tempFilter?.billingEndDateDatepicker &&
                    date.isAfter(tempFilter.billingEndDateDatepicker, "day")
                  }
                />
              </LocalizationProvider>
              {touched.billingStartDateDatepicker && errors.startDate && (
                <FormHelperText>{errors.startDate}</FormHelperText>
              )}
            </FormControl>

            <FormControl
              sx={{ width: "100%" }}
              variant="standard"
              error={!!(touched.billingEndDateDatepicker && errors.endDate)}
            >
              <p className="label">Billing Period End Date:</p>
              <LocalizationProvider
                sx={{ marginBottom: "0px !important" }}
                dateAdapter={AdapterDayjs}
              >
                <DatePicker
                  className="filter-biiling-date"
                  name="billingEndDateDatepicker"
                  id="billingEndDateDatepicker"
                  value={tempFilter?.billingEndDateDatepicker || null}
                  onChange={(dateValue) =>
                    handleChangeBillingEndDate(dateValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        ".MuiInputBase-root": {
                          outline:
                            touched.billingEndDateDatepicker && errors.endDate
                              ? "red"
                              : tempFilter?.billingStartDateDatepicker &&
                                params?.inputProps?.disabled
                              ? "yellow"
                              : "",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            outline:
                              touched.billingEndDateDatepicker && errors.endDate
                                ? "red"
                                : tempFilter?.billingStartDateDatepicker &&
                                  params?.inputProps?.disabled
                                ? "yellow"
                                : "",
                          },
                        },
                        ".MuiInputBase-root.Mui-error": {
                          outline: "red",
                        },
                      }}
                    />
                  )}
                  allowClear
                  shouldDisableDate={(date) =>
                    tempFilter?.billingStartDateDatepicker &&
                    date.isBefore(tempFilter.billingStartDateDatepicker, "day")
                  }
                />
              </LocalizationProvider>
              {touched.billingEndDateDatepicker && errors.endDate && (
                <FormHelperText>{errors.endDate}</FormHelperText>
              )}
            </FormControl>
          </Stack>

          <Stack
            sx={{ mt: "11px" }}
            direction="row"
            alignItems="center"
            spacing={4}
          >
            <FormControl
              className="search-box filter-searchbox"
              sx={{ m: 1, maxWidth: "357px" }}
            >
              <p className="label">Status</p>
              <Select
                sx={{
                  ".MuiSelect-select": {
                    color:
                      tempFilter?.invoiceStatus === ""
                        ? "#898989 !important" // Gray color for placeholder
                        : "#212121 !important", // Black color for selected value
                  },
                  minWidth: tempFilter?.invoiceStatus ? "0px" : "100%",
                  paddingRight: tempFilter?.invoiceStatus ? "14px" : "0px",
                }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={tempFilter?.invoiceStatus || ""}
                onChange={handleChangeInvoiceStatus}
                IconComponent={KeyboardArrowDownIcon}
                displayEmpty
                // renderValue={(selected) => {
                //   return selected === "" ? "Select Status" : selected; // Show "Select Status" as placeholder when no value is selected
                // }}
                endAdornment={
                  <InputAdornment position="start">
                    {tempFilter?.invoiceStatus ? (
                      <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={clearProject}
                      >
                        <HighlightOffIcon fontSize="small" />
                      </IconButton>
                    ) : (
                      ""
                    )}
                  </InputAdornment>
                }
              >
                <MenuItem disabled value="">
                  Select Status
                </MenuItem>
                <MenuItem value={1}>Statement Open</MenuItem>
                <MenuItem value={2}>Statement Closed</MenuItem>
                <MenuItem value={3}>Invoice Started</MenuItem>
                {/* <MenuItem value={4}>Invoice Closed</MenuItem> */}
              </Select>
            </FormControl>
          </Stack>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "25px 34px", pt: "15px" }}
        >
          <Button
            className="filter-btn"
            type="submit"
            // disabled={tempFilter?.billingEndDate == "" &&  tempFilter?.billingStartDate == "" &&
            //   tempFilter?.invoiceStatus == ""}
          >
            Apply Filter
          </Button>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
